export const environment = {
  production: window['env']['production'] || true,
  namespace: window['env']['namespace'] || 'metadoor',

  // Yandex Metrika settings

  yandexMetrika: {
    enabled: window['env']?.['yandexMetrika']?.['enabled'] ?? false,
    counterId: window['env']?.['yandexMetrika']?.['counterId'] ||
      (window['env']?.['namespace'] === 'rshb' ? 98448894 : 75328399)
  },

  // apiUrl: window['env']['apiUrl'] || 'https://feature-499.dev.api.metadoor-invest.com/api',
  // baseUrl: window['env']['baseUrl'] || 'https://feature-499.dev.api.metadoor-invest.com',
  // wssUrl: window['env']['wssUrl'] || 'wss://feature-499.dev.api.metadoor-invest.com/ws',

  apiUrl: window['env']['apiUrl'] || 'https://dev.api.metadoor-invest.com/api',
  baseUrl: window['env']['baseUrl'] || 'https://dev.api.metadoor-invest.com',
  wssUrl: window['env']['wssUrl'] || 'wss://dev.api.metadoor-invest.com/ws',
  monitoringUrl: window['env']['monitoringUrl'] || 'https://monitoring.dev.metadoor-invest.com',
  // CI на feature-стендах может подставить placeholder как 'https://' (пустой host) —
  // нужен .includes('.') иначе interceptor сматчит ВСЕ https-запросы и сломает логин.
  analyticsApiUrl: (typeof window['env']['analyticsApiUrl'] === 'string' && window['env']['analyticsApiUrl'].includes('.'))
    ? window['env']['analyticsApiUrl']
    : 'https://analytics.dev.metadoor-invest.com',
  analyticsGrafanaUrl: (typeof window['env']['analyticsGrafanaUrl'] === 'string' && window['env']['analyticsGrafanaUrl'].includes('.'))
    ? window['env']['analyticsGrafanaUrl']
    : 'https://grafana.dev.metadoor-invest.com',
  // Сервис-оптимизатор (Optimization Engine) — отдельный хост + JWT (как analyticsApiUrl).
  optimizerApiUrl: (typeof window['env']['optimizerApiUrl'] === 'string' && window['env']['optimizerApiUrl'].includes('.'))
    ? window['env']['optimizerApiUrl']
    : 'https://optimizer.dev.metadoor-invest.com',

  referenceUrl:
    'https://gitlab.services.metadoor-invest.com/metadoor-invest-dev/metadoor-invest-frontend/uploads/1bc9be9ff37015ca97d98463237d5557/%D0%A0%D1%83%D0%BA%D0%BE%D0%B2%D0%BE%D0%B4%D1%81%D1%82%D0%B2%D0%BE_%D0%BA_%D0%BF%D1%80%D0%BE%D0%B3%D1%80%D0%B0%D0%BC%D0%BC%D0%B5_MetaDoor-Invest.pdf',

  // contacts
  contactTelegram: 'https://t.me/metadoor_invest_bot',
  contactPhone: '+7 967 017 63 60',
  contactEmail: 'info@metadoor-dev.com',
  supportEmail: 'support@metadoor-dev.com',
  chartLoaderColor: window['env']['chartLoaderColor'] || '#91CC75',
  axiesColors: window['env']['axiesColors'] || ['#5470C6', '#91CC75'],
  metrixСolors: window['env']['metrixСolors'] || {
    default: '#a00000',
    roi_fact: '#12d2d2',
    roi_plan: '#a2aaff',
    nvp_fact: '#12d268',
    nvp_plan: '#3242d2',
    revenue_plan: '#a242d2',
    revenue_fact: '#b242d2',
    cost_price_plan: '#c2d2d2',
    cost_price_fact: '#c2a2d2',
    opex_plan: '#1242d2',
    opex_fact: '#12a2d2',
    interest_expenses_plan: '#32a2d2',
    interest_expenses_fact: '#32f2d2',
    ebitda_plan: '#32d2f2',
    ebitda_fact: '#32a2f2',
    net_profit_plan: '#f242d2',
    net_profit_fact: '#f2f2d2',
    npv_plan: '#121212',
    npv_fact: '#3dd2d2',
    return_on_sales_rot_plan: '#e242d2',
    return_on_sales_rot_fact: '#e2e57d',
    return_plan: '#323272',
    return_fact: '#f24d52',
    ebit_to_interest_plan: '#9F8170',
    ebit_to_interest_fact: '#ACB78E',
    return_on_assets_roa_plan: '#FFB02E',
    return_on_assets_roa_fact: '#900020',
    return_on_equity_roe_plan: '#45161C',
    return_on_equity_roe_fact: '#D5713F',
    autonomy_coefficient_plan: '#9ACEEB',
    autonomy_coefficient_fact: '#DAD871',
    leverage_ratio_de_plan: '#34C924',
    leverage_ratio_de_fact: '#DE4C8A',
    debt_to_ebitda_plan: '#B8B799',
    debt_to_ebitda_fact: '#641349',
    irr_plan: '#80DAEB',
    irr_fact: '#EDFF21',
    // Цвет показателей для графиков
    business_expenses: '#32B2f2',
    fixed_opexs: '#A0fAA1',
    gross_profit: '#A4C924',
    income_tax: '#C0C020',
    management_expenses: '#f2f2d2',
    operating_income_ebit: '#323272',
    profit_before_tax: '#a00000',
    variables_opexs: '#ff8900',
    // cash_flow_plan_data
    ebitda: "#4363D8",                              // Синий
    working_weight_change: "#F58231",               // Оранжевый
    net_cash_flow_from_operations: "#3CB44B",       // Зеленый
    payment_capital_costs: "#E6194B",               // Красный
    vat_refund: "#911EB4",                          // Фиолетовый
    payment_liquidation_expenses: "#42D4F4",        // Голубой
    receipt_liquidation_proceeds: "#F032E6",        // Пурпурный
    net_cash_flow_from_investing_activities: "#E6B800", // Темно-желтый/Золотой
    receipt_from_owners: "#469990",                 // Бирюзовый
    incoming_from_investors: "#D2691E",             // Шоколадный
    payments_to_investors: "#000075",               // Темно-синий
    dividends_payment: "#9370DB",                   // Средний фиолетовый
    credit_receipt: "#00FA9A",                      // Яркий мятный
    return_credits: "#800000",                      // Темно-бордовый
    interest_payment: "#8DB600",                    // Оливковый
    net_cash_flow_from_financing_activities: "#FF6347", // Томатный
    net_cash_flow: "#6A5ACD",                       // Сланцевый синий
    cash_balance_beginning_period: "#20B2AA",       // Светло-морской
    cash_balance_the_end_period: "#556B2F",         // Темно-оливковый
    // balanc chart
    fixed_assets: "#4363D8",                        // Синий
    total_non_current_assets: "#F58231",            // Оранжевый
    stocks: "#3CB44B",                              // Зеленый
    investor_funds: "#E6194B",                      // Красный
    intangible_assets: "#911EB4",                   // Фиолетовый
    vat_purchased_assets: "#42D4F4",                // Голубой
    accounts_receivable: "#F032E6",                 // Пурпурный
    cash: "#E6B800",                                // Темно-желтый/Золотой
    total_current_assets: "#469990",                // Бирюзовый
    total_balance: "#D2691E",                       // Шоколадный
    authorized_share_capital: "#000075",            // Темно-синий
    undestributed_profits: "#9370DB",               // Средний фиолетовый
    total_equity: "#00FA9A",                        // Яркий мятный
    borrowed_funds: "#800000",                      // Темно-бордовый
    accounts_payable: "#8DB600",                    // Оливковый
    total_liabilities: "#FF6347",                   // Томатный
    total_balance2: "#6A5ACD",                      // Сланцевый синий
    // results-of-financial-analysis
    return_on_sales_rot: "#4363D8",                 // Синий
    return_on_equity_roe: "#F58231",                // Оранжевый
    return_on_assets_roa: "#3CB44B",                // Зеленый
    asset_turnover_ratio: "#E6194B",                // Красный
    current_assets_turnover_ratio: "#911EB4",       // Фиолетовый
    inventory_turnover_ratio: "#42D4F4",            // Голубой
    accounts_receivable_turnover_ratio: "#F032E6",  // Пурпурный
    autonomy_coefficient: "#E6B800",                // Темно-желтый/Золотой
    leverage_ratio_de: "#469990",                   // Бирюзовый
    own_working_capital_ratio: "#D2691E",           // Шоколадный
    absolute_liquidity_ratio: "#000075",            // Темно-синий
    //  : "#9370DB",               // Средний фиолетовый
    interim_liquidity_ratio: "#00FA9A",             // Яркий мятный
    //  : "#800000",                      // Темно-бордовый
    accounts_payable_turnover_ratio: "#8DB600",     // Оливковый
    current_liquidity_ratio: "#FF6347",             // Томатный
    debt_to_ebitda: "#6A5ACD",                       // Сланцевый синий
    //  investor report
    investment_amount: "#4363D8",                    // Синий
    dividends: "#F58231",                            // Оранжевый
    cash_flow_payments: "#3CB44B",                   // Зеленый
    sales_payments: "#E6194B",                       // Красный
    fixed_sum_payments: "#911EB4",                   // Фиолетовый
    realization_payments: "#42D4F4",                 // Голубой
    loan_return: "#F032E6",                          // Пурпурный
    loan_interests: "#E6B800",                       // Темно-желтый/Золотой
    accumulated_financial_result: "#469990",         // Бирюзовый
    // sales plan
    product_product_name: "#4363D8",              // Синий
    product_price: "#F58231",                     // Оранжевый
    product_volume: "#3CB44B",                    // Зеленый
    product_revenue_with_vat: "#E6194B",          // Красный
    product_vat: "#911EB4",                       // Фиолетовый
    product_revenue_without_vat: "#42D4F4",       // Голубой
    total_price: "#F032E6",                       // Пурпурный
    total_volume: "#E6B800",                      // Темно-желтый/Золотой
    total_revenue_with_vat: "#469990",            // Бирюзовый
    total_vat: "#D2691E",                         // Шоколадный
    total_revenue_without_vat: "#000075"          // Темно-синий
  },
};
